import { useState, useEffect } from 'react';

interface VersionInfo {
  version: string;
  buildDate: string;
  buildTimestamp: number;
  commitHash: string;
  environment: string;
}

export const Footer = () => {
  const [versionInfo, setVersionInfo] = useState<VersionInfo | null>(null);

  useEffect(() => {
    // Importar dinamicamente o arquivo de versão
    import('../version.json')
      .then((data) => {
        setVersionInfo(data.default);
      })
      .catch((error) => {
        console.warn('Não foi possível carregar informações da versão:', error);
        // Fallback com informações básicas
        setVersionInfo({
          version: '0.0.1',
          buildDate: new Date().toISOString(),
          buildTimestamp: Date.now(),
          commitHash: 'local',
          environment: 'development',
        });
      });
  }, []);

  const formatDate = (dateString: string) => {
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      });
    } catch {
      return 'Data inválida';
    }
  };

  return (
    <div className="mb-24 mt-1 lg:mb-0 text-center text-sm">
      <div className="text-black flex items-center justify-between gap-3 mb-2">
        <a
          className="cursor-pointer hover:text-black/80"
          href="https://coracoespreciosos.com.br/contrato"
          target="_blank"
          rel="noopener noreferrer"
        >
          Termos de uso
        </a>
        <a
          className="cursor-pointer hover:text-black/80"
          href="https://coracoespreciosos.com.br/politica-de-privacidade/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Políticas de privacidade
        </a>
      </div>

      {/* Informações da versão */}
      {versionInfo && (
        <div className="text-xs text-gray-500 mt-2">
          <div className="flex items-center justify-center gap-4">
            <span>v{versionInfo.version}</span>
            <span>•</span>
            <span>{formatDate(versionInfo.buildDate)}</span>
            {versionInfo.environment !== 'production' && (
              <>
                <span>•</span>
                <span className="text-orange-600 font-medium">{versionInfo.environment}</span>
              </>
            )}
          </div>
          {versionInfo.commitHash !== 'local' && (
            <div className="text-xs text-gray-400 mt-1">Commit: {versionInfo.commitHash.substring(0, 7)}</div>
          )}
        </div>
      )}

      <div className="text-xs text-gray-400 mt-2">Todos os direitos reservados © {new Date().getFullYear()}</div>
    </div>
  );
};
